export const environment = {
    production: true,
    api_base_url: '/api',
    base_url: 'http://preprod-a2l.arcane-labs.net',
};
